'use strict';

export default {
  loginPage: {
    username: "Nom d'utilisateur",
    email: 'Courriel',
    password: 'Mot de passe',
    login: 'Connexion',
    stayconnected: 'Se souvenir de moi',
    wrongCombination: 'Votre combinaison e-mail/mot de passe est incorrecte',
    or: 'Ou',
    emailError: 'Le courriel est un champs obligatoire',
    passwordError: 'Le mot de passe est obligatoire',
    confirmPassword: 'Confirmer le mot de passe',
    confirmPasswordError: 'La confirmation du mot de passe est obligatoire',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    firstNameError: 'Le prénom est un champs obligatoire',
    lastNameError: 'Le nom de famille est un champs obligatoire',
    firstNameLengthError: 'Le prénom doit contenir entre 2 et 50 caractères',
    lastNameLengthError: 'Le nom de famille doit contenir entre 2 et 50 caractères',
    passwordLengthError: 'Le mot de passe doit contenir au moins 4 caractères',
    emailValidError: 'Le courriel doit être valide',
    passwordMustMatchError: 'Les mots de passe doivent correspondre',
    confirmPasswordRequiredError: 'La confirmation du mot de passe est un champs obligatoire',
    createAccount: 'Créer un compte',
    alreadyHaveAccount: 'Vous avez déjà un compte?',
    noAccount: "Vous n'avez pas de compte?",
    logIn: 'Se connecter',
    signUp: "S'inscrire",
    awaitingActivation: "En attente de l'activation du compte. Veuillez vérifier votre courriel.",
    emailExistsError: 'Un compte avec cet e-mail existe déjà.',
    fromRegistrationToCelebration: "De l'inscription à la célébration!",
    welcomeBack: 'Bienvenue ! Veuillez vous connecter à votre compte.',
  },
  activateAccountPage: {
    activatingAccount: 'Activation du compte...',
    activationSuccess: 'Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter.',
    activationFailure:
      "Échec de l'activation du compte. Veuillez vérifier votre lien d'activation ou contacter le support.",
    backToLogin: 'Retour à la page connexion',
    login: 'Se connecter',
  },
  accountCreatedPage: {
    accountCreatedSuccess:
      "Félicitations! Votre compte Kreezee a été créé avec succès. Un courriel vous a été acheminé afin d'activer votre compte.",
    backToLogin: 'Retour à la page connexion',
  },
};
